// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v2/maas.proto (package infinigence.infini.agentplatform.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v2/maas.proto.
 */
export const file_agentplatform_v2_maas: GenFile = /*@__PURE__*/
  fileDesc("ChthZ2VudHBsYXRmb3JtL3YyL21hYXMucHJvdG8SI2luZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYyIt8CCg5NYWFzQ3JlZGVudGlhbBIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEj8KBnZlbmRvchgDIAEoDjIvLmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYyLk1hYXNWZW5kb3ISGAoHYXBpX2tleRgEIAEoCVIHYXBpX2tleRIaCghiYXNlX3VybBgFIAEoCVIIYmFzZV91cmwSJAoNZGVmYXVsdF9tb2RlbBgGIAEoCVINZGVmYXVsdF9tb2RlbBIcCgl0ZW5hbnRfaWQYByABKAlSCXRlbmFudF9pZBIYCgd1c2VyX2lkGAggASgJUgd1c2VyX2lkEh4KCmNyZWF0ZWRfYXQYCSABKANSCmNyZWF0ZWRfYXQSHgoKdXBkYXRlZF9hdBgKIAEoA1IKdXBkYXRlZF9hdBIeCgpkZWxldGVkX2F0GAsgASgDUgpkZWxldGVkX2F0Io8BCglNYWFzTW9kZWwSDAoEbmFtZRgBIAEoCRIsChFtYXhfb3V0cHV0X2xlbmd0aBgCIAEoA1IRbWF4X291dHB1dF9sZW5ndGgSJgoOY29udGV4dF9sZW5ndGgYAyABKANSDmNvbnRleHRfbGVuZ3RoEh4KCm1vZGVsX3R5cGUYBCABKAlSCm1vZGVsX3R5cGUqNwoKTWFhc1ZlbmRvchIbChdNQUFTX1ZFTkRPUl9VTlNQRUNJRklFRBAAEgwKCEluZmluaUFJEAFCSVpHZ2l0bGFiLmluZmluaS1haS5jb20vbWl6YXIvaW5maW5pYWktYWdlbnRpYy1pbmZyYS9jb21tb24vZ3JwY2FwaXMvdjI7djJiBnByb3RvMw");

/**
 * MaasCredential 租户下的 MaaS 接入凭证 / MaaS access credential under a tenant
 *
 * @generated from message infinigence.infini.agentplatform.v2.MaasCredential
 */
export type MaasCredential = Message<"infinigence.infini.agentplatform.v2.MaasCredential"> & {
  /**
   * 记录 ID / Record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 凭证名称 / Credential name
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 供应商 / Vendor
   * @gotags: json:"vendor,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.MaasVendor vendor = 3;
   */
  vendor: MaasVendor;

  /**
   * API Key（脱敏展示）/ API Key (masked)
   * @gotags: json:"api_key,omitempty"
   *
   * @generated from field: string api_key = 4 [json_name = "api_key"];
   */
  apiKey: string;

  /**
   * OpenAI 兼容 API 根路径 / OpenAI-compatible API base URL
   * @gotags: json:"base_url,omitempty"
   *
   * @generated from field: string base_url = 5 [json_name = "base_url"];
   */
  baseUrl: string;

  /**
   * 默认模型 / Default model
   * @gotags: json:"default_model,omitempty"
   *
   * @generated from field: string default_model = 6 [json_name = "default_model"];
   */
  defaultModel: string;

  /**
   * 所属租户 ID / Tenant ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 7 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 创建者用户 ID / Creator user ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 8 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 创建时间（unix nano）/ Created at (unix nano)
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 9 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * 更新时间（unix nano）/ Updated at (unix nano)
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 10 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * 删除时间（unix nano，软删）/ Deleted at (unix nano, soft delete)
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 11 [json_name = "deleted_at"];
   */
  deletedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v2.MaasCredential.
 * Use `create(MaasCredentialSchema)` to create a new message.
 */
export const MaasCredentialSchema: GenMessage<MaasCredential> = /*@__PURE__*/
  messageDesc(file_agentplatform_v2_maas, 0);

/**
 * MaasModel 可用模型信息 / Available model info
 *
 * @generated from message infinigence.infini.agentplatform.v2.MaasModel
 */
export type MaasModel = Message<"infinigence.infini.agentplatform.v2.MaasModel"> & {
  /**
   * 模型名称 / Model name
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 最大输出长度 / Max output length
   * @gotags: json:"max_output_length,omitempty"
   *
   * @generated from field: int64 max_output_length = 2 [json_name = "max_output_length"];
   */
  maxOutputLength: bigint;

  /**
   * 上下文长度 / Context length
   * @gotags: json:"context_length,omitempty"
   *
   * @generated from field: int64 context_length = 3 [json_name = "context_length"];
   */
  contextLength: bigint;

  /**
   * 模型类型 / Model type
   * @gotags: json:"model_type,omitempty"
   *
   * @generated from field: string model_type = 4 [json_name = "model_type"];
   */
  modelType: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v2.MaasModel.
 * Use `create(MaasModelSchema)` to create a new message.
 */
export const MaasModelSchema: GenMessage<MaasModel> = /*@__PURE__*/
  messageDesc(file_agentplatform_v2_maas, 1);

/**
 * MaasVendor MaaS 供应商 / MaaS vendor
 * Mirror of v1.MaasVendor — field names preserved verbatim (mixed-prefix v1 enum: MAAS_VENDOR_UNSPECIFIED is prefixed, InfiniAI is bare).
 *
 * @generated from enum infinigence.infini.agentplatform.v2.MaasVendor
 */
export enum MaasVendor {
  /**
   * 未指定 / Unspecified
   *
   * @generated from enum value: MAAS_VENDOR_UNSPECIFIED = 0;
   */
  MAAS_VENDOR_UNSPECIFIED = 0,

  /**
   * InfiniAI (bare name mirrors v1 verbatim)
   *
   * @generated from enum value: InfiniAI = 1;
   */
  InfiniAI = 1,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v2.MaasVendor.
 */
export const MaasVendorSchema: GenEnum<MaasVendor> = /*@__PURE__*/
  enumDesc(file_agentplatform_v2_maas, 0);

